import React from 'react';
import {Button,Modal,ModalBody,ModalFooter} from "react-bootstrap"
// import {Modal,Button} from 'react-bootstrap'

const DeleteProjectModal = (props) => {
    return (
        <Modal show={props.modal}
        onHide={props?.toggle}
            backdrop="static"
            keyboard={"false"}>
            <Modal.Body>
                <p>Êtes-vous sûr de vouloir supprimer ce projet
                </p>
            </Modal.Body>

            <Modal.Footer style={{border:"none"}}>
                <Button variant="primary" onClick={props?.onYes}>Oui</Button>
                <Button variant="secondary" onClick={props?.toggle}>Non</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default DeleteProjectModal;
